// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"362d9906","306":"0c949606","615":"1797ff55","740":"c90bfb6d","766":"b45bcea4"}[chunkId] + ".chunk.js";
};